import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, take, finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

export const LoadingInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const loadingService = inject(LoadingService);
  let handleRequestsAutomatically = false;

  loadingService.auto$.pipe(take(1)).subscribe((value) => {
    handleRequestsAutomatically = value;
  });

  // If the Auto mode is turned off, do nothing.... I'm not sure this really works the way I want it to, so let's try something else for now...
  // if (!handleRequestsAutomatically) {
  //   return next(req);
  // }
  
  // Provide a way to skip this interceptor, add a skip-error-interceptor header
  // Is this good? Should we remove the header once this has been triggered?
  if (req.headers.has('skip-loading-interceptor')) {
    return next(req);
  }
  // Set the loading status to true
  loadingService._setLoadingStatus(true, req.url);

  return next(req).pipe(
    finalize(() => {
      // Set the status to false if there are any errors or the request is completed
      loadingService._setLoadingStatus(false, req.url);
    }),
  );
};
